import { selectors, constants } from 'app-webtech-core';
import { changeUrlSlug as changeUrlSlugCommon } from 'app-source/actions/changeUrlSlug';
import { googPalRequest } from 'app-modules/application/actions';
import {
  VOD,
  VOD_MOVIE,
  VOD_SERIES_EPISODE,
  VOD_SERIES_SEASON_EPISODE,
} from '../../../routes/types';

export const changeUrlSlug = () => (dispatch, getState) => {
  const state = getState();
  const content = selectors.player.content(state);

  let itemType;
  const payload = {};
  if (content) {
    if (content.type === constants.vodContent.VOD_CONTENT_TYPE.MOVIES) {
      itemType = VOD_MOVIE;
      payload.movieSlug = content.slug;
    } else if (content.type === constants.vodContent.VOD_CONTENT_TYPE.EPISODE) {
      payload.seriesSlug = content.serieSlug;
      payload.episodeSlug = content.slug;
      itemType = VOD_SERIES_EPISODE;
      if (typeof content.raw.season !== 'undefined') {
        payload.seasonNumber = content.raw.season;
        itemType = VOD_SERIES_SEASON_EPISODE;
      }
    }
  }
  dispatch(googPalRequest());
  dispatch(changeUrlSlugCommon(itemType, VOD)(payload));
};
